import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const BeginnerIcon = ({ className }) => (_jsxs("svg", Object.assign({ className: `svg-beginner-icon ${className}`, height: '21.177', viewBox: '0 0 15.721 21.177', width: '15.721', xmlns: 'http://www.w3.org/2000/svg' }, { children: [_jsx("path", { d: 'M513.342,2481.324a1.15,1.15,0,0,0-1.943.834v12.486a1.151,1.151,0,0,0,.306.781l6.7,6.385a1.124,1.124,0,0,0,.835.37h.032l-.016-15.8Z', fill: '#ede123', transform: 'translate(-511.399 -2481.005)' }), _jsx("path", { d: 'M1005.263,2481.324a1.15,1.15,0,0,1,1.943.834v12.486a1.15,1.15,0,0,1-.306.781l-6.7,6.385a1.124,1.124,0,0,1-.835.37h-.032l.016-15.8Z', fill: '#61ad99', transform: 'translate(-991.485 -2481.005)' })] })));
BeginnerIcon.propTypes = {
    className: propStr(),
};
BeginnerIcon.defaultProps = {
    className: '',
};
export default BeginnerIcon;
